import { mapGetters } from 'vuex'

export const PermissionMiddleware = {
  data () {
    return {
      schoolAdmin: false,
      createModuleAction: false,
      editModuleAction: false,
      viewModuleAction: false,
      viewModuleActionNotification: false,
      viewModuleActionNotificationTem: false,
      createModuleActionNotificationTem: false,
      editModuleActionNotificationTem: false,
      deleteModuleActionNotificationTem: false,
      deleteModuleAction: false,
      sendModuleAction:false,
      converModuleAction:false,
      shareModuleAction:false,
      enrollModuleAction:false,
      customCreateAction:false,
      customEditAction:false,
      customDeleteAction:false,
      studentSchedulePermission:false,
      roomSchedulePermission:false,
      teacherSchedulePermission:false,
      manualEnrollment:false,
      markAttendanceModule:false,
      saveModuleAction:false,
      generateGraphModule:false,
      projectCreate:false,
      projectEdit:false,
      projectView:false,
      projectDelete:false,
      blogCreate: false,
      blogEdit: false,
      blogShare: false,
      blogView: false,
      blogDelete: false,
      modulePermission:[],
      certificateCreate:false,
      certificateEdit:false,
      certificateDelete:false,
      certificateShares:false,
      certificateGeneratePermission:false,
      certificateTempView:false,
      certificategenerateView:false,
      certificategenerateDelete:false,
      certificateTabView:false,
      cancelReschedulePermission:false,
      Rescheduling:false,
      assignmentBuilder:{
        reports:false,
        exams:false,
        questionbank:false,
        homework:false
      },
      payoutSettingEdit: false,
      generaatePaySlip:false,
      financeApproval:false,
      admissionEnroll: false,
      admissionView: false,
      gradebookListView: false,
      gradebookClassShare: false,
      gradebookCourseShare: false,
      gradebookSettingsListView: false,
      gradebookSettingsEdit: false,
      gradebookClassListView: false,
      marksEntry: false,
      studentClassScheduleView: false,
      teacherClassScheduleView: false,
      submodulePermission:[],
      viewSubModule: false

    }
  },
  methods: {
     getSubModulePermission (moduleName, subModuleName, permissionType) {
      
      if (this.schoolAdmin) return true

      const modulePermission = this.get_navmenu_item_data.filter(ele => {
        return ele.module_name === moduleName
      })        

      const submodulePermission =  modulePermission[0].sub_modules.filter(item => {
        return item.sub_module_name === subModuleName
      })
  
      return submodulePermission[0].enabled
    },
    async getModulePermission (moduleName, smsOrEmail = null, room = false, inventory = false) {
      const modulePermission = this.get_navmenu_item_data.filter(ele => {
        return ele.module_name === moduleName
      })


      //we will check permission
      if (modulePermission[0].sub_modules.length) {
        this.setPermissionAction(modulePermission[0].sub_modules, smsOrEmail, room, inventory)
      }
    },
    setPermissionAction (modulePermissionAction, smsOrEmail = null, room = false, inventory = false) {
      modulePermissionAction.forEach(element => {
        if (element.action_name === 'View' && element.enabled === 1 && smsOrEmail === null) {
          this.viewModuleAction = true
        } else if ((element.action_name === 'Create' || element.action_name === 'createPushTemplate') && element.enabled === 1 && smsOrEmail === null) {
          this.createModuleAction = true
        } else if (element.action_name === 'Edit' && element.enabled === 1 && smsOrEmail === null) {
          this.editModuleAction = true
        } else if (element.action_name === 'Delete' && element.enabled === 1 && smsOrEmail === null) {
          this.deleteModuleAction = true
        } else if (element.action_name === 'convertLead' && element.enabled === 1) {
          this.converModuleAction = true
        } else if ((element.action_name === 'Share' || element.action_name === 'share' || element.action_name === 'shareCourse' || element.action_name === 'shareAssignment') && element.enabled === 1) {
          this.shareModuleAction = true
        }  else if ((element.action_name === 'enroll') && element.enabled === 1) {
          this.enrollModuleAction = true
        } else if ((element.action_name === 'StudentEnrollment') && element.enabled === 1) {
          this.manualEnrollment = true
        } else if (element.action_name === 'Create'  && smsOrEmail === 'blog' && element.enabled === 1) {
          this.blogCreate = true
        } else if (element.action_name === 'View' && smsOrEmail === 'blog' && element.enabled === 1) {
          this.blogView = true
        } else if (element.action_name === 'Edit' && smsOrEmail === 'blog' && element.enabled === 1) {
          this.blogEdit = true
        } else if (element.action_name === 'Delete' && smsOrEmail === 'blog' && element.enabled === 1) {
          this.blogDelete = true
        }  else if (element.action_name === 'shareBlog' && smsOrEmail === 'blog' && element.enabled === 1) {
          this.blogShare = true
        } else if (element.action_name === 'CreateEmailTemplate'  && smsOrEmail === 'email' && element.enabled === 1) {
          this.createModuleAction = true
        } else if (element.action_name === 'ViewEmailTemplate' && smsOrEmail === 'email' && element.enabled === 1) {
          this.viewModuleAction = true
        } else if (element.action_name === 'EditEmailTemplate' && smsOrEmail === 'email' && element.enabled === 1) {
          this.editModuleAction = true
        } else if (element.action_name === 'DeleteEmailTemplate' && smsOrEmail === 'email' && element.enabled === 1) {
          this.deleteModuleAction = true
        } else if ((element.action_name === 'compose') &&  smsOrEmail === 'email' && element.enabled === 1) {
          this.sendModuleAction = true
        } else if (element.action_name === 'CreateSmsTemplate' && smsOrEmail === 'sms'  && element.enabled === 1) {
          this.createModuleAction = true
        } else if (element.action_name === 'ViewSmsTemplate'  && smsOrEmail === 'sms' && element.enabled === 1) {
          this.viewModuleAction = true
        } else if (element.action_name === 'EditSmsTemplate'  && smsOrEmail === 'sms' && element.enabled === 1) {
          this.editModuleAction = true
        } else if (element.action_name === 'DeleteSmsTemplate' && smsOrEmail === 'sms' && element.enabled === 1) {
          this.deleteModuleAction = true
        } else if (element.action_name === 'SendSms' && smsOrEmail === 'sms' && element.enabled === 1) {
          this.sendModuleAction = true
        } else if (element.action_name === 'customCreate' && element.enabled === 1) {
          this.customCreateAction = true
        } else if (element.action_name === 'customEdit' && element.enabled === 1) {
          this.customEditAction = true
        } else if (element.action_name === 'customDelete' && element.enabled === 1) {
          this.customDeleteAction = true
        } else if (element.action_name === 'viewPushTemplate' && element.enabled === 1) {
          this.viewModuleActionNotificationTem = true
        } else if (element.action_name === 'editPushTemplate' && element.enabled === 1) {
          this.editModuleActionNotificationTem = true
        } else if (element.action_name === 'deletePushTemplate' && element.enabled === 1) {
          this.deleteModuleActionNotificationTem = true
        }  else if (element.action_name === 'viewNotification' && element.enabled === 1) {
          this.viewModuleActionNotification = true
        } else if (element.action_name === 'Student permission' && element.enabled === 1) {
          this.studentSchedulePermission = true
        }  else if (element.action_name === 'Room view' && element.enabled === 1) {
          this.roomSchedulePermission = true
        } else if (element.action_name === 'Teacher permission' && element.enabled === 1) {
          this.teacherSchedulePermission = true
        } else if (element.action_name === 'createRoom' && room && element.enabled === 1) {
          this.createModuleAction = true
        } else if (element.action_name === 'editRoom' && room && element.enabled === 1) {
          this.editModuleAction = true
        } else if (element.action_name === 'deleteRoom' && room && element.enabled === 1) {
          this.deleteModuleAction = true
        } else if (element.action_name === 'createInventory' && inventory && element.enabled === 1) {
          this.createModuleAction = true
        } else if (element.action_name === 'editInventory' && inventory && element.enabled === 1) {
          this.editModuleAction = true
        } else if (element.action_name === 'deleteInventory' && inventory && element.enabled === 1) {
          this.deleteModuleAction = true
        } else if (element.action_name === 'markAttendance'  && element.enabled === 1) {
          this.markAttendanceModule = true
        //graph
        } else if (element.action_name === 'createBasicGraph'  && element.enabled === 1) {
          this.generateGraphModule = true
        } else if (element.action_name === 'deleteGraph'  && element.enabled === 1) {
          this.deleteModuleAction = true
        } else if (element.action_name === 'saveGraphs'  && element.enabled === 1) {
          this.saveModuleAction = true
        } else if (element.action_name === 'CreateProject'  && element.enabled === 1) {
          this.projectCreate = true
        } else if (element.action_name === 'EditProject'  && element.enabled === 1) {
          this.projectEdit = true
        } else if (element.action_name === 'ViewProject'  && element.enabled === 1) {
          this.projectView = true
        } else if (element.action_name === 'DeleteProject'  && element.enabled === 1) {
          this.projectDelete = true
        } else if (element.action_name === 'CertificateTemplateCreate'  && element.enabled === 1) {
          this.certificateCreate = true
        } else if (element.action_name === 'CertificateTemplateDelete'  && element.enabled === 1) {
          this.certificateDelete = true
        } else if (element.action_name === 'CertificateTemplateEdit'  && element.enabled === 1) {
          this.certificateEdit = true
        } else if (element.action_name === 'CertificateShare'  && element.enabled === 1) {
          this.certificateShares = true
        } else if (element.action_name === 'CertificateGenerate'  && element.enabled === 1) {
          this.certificateGeneratePermission = true
        } else if (element.action_name === 'CertificateTemplateView'  && element.enabled === 1) {
          this.certificateTempView = true
        } else if (element.action_name === 'GeneratedCertificateView'  && element.enabled === 1) {
          this.certificategenerateView = true
        } else if (element.action_name === 'GeneratedCertificateDelete'  && element.enabled === 1) {
          this.certificategenerateDelete = true
        } else if (element.action_name === 'View'  && element.enabled === 1) {
          this.certificateTabView = true
        } else if (element.action_name === 'PayoutSettingEdit'  && element.enabled === 1) {
          this.payoutSettingEdit = true
        } else if (element.action_name === 'paymentApproval'  && element.enabled === 1) {
          this.generaatePaySlip = true
        } else if (element.action_name === 'FinanceApproved'  && element.enabled === 1) {
          this.financeApproval = true
        } else if (element.action_name === 'cancelSchedule'  && element.enabled === 1) {
          this.cancelReschedulePermission = true
        } else if (element.action_name === 'Reschedule Session'  && element.enabled === 1) {
          this.Rescheduling = true
        } else if (element.action_name === 'StudentEnrollment'  && element.enabled === 1) {
          this.admissionEnroll = true
          // Grade
        } else if (element.action_name === 'GradebookListView' && element.enabled === 1) {
          this.gradebookListView = true
        } else if (element.action_name === 'ShareClassGradebook' && element.enabled === 1) {
          this.gradebookClassShare = true
        } else if (element.action_name === 'ShareCourseGradebook' && element.enabled === 1) {
          this.gradebookCourseShare = true
        } else if (element.action_name === 'GradeSettingsListView' && element.enabled === 1) {
          this.gradebookSettingsListView = true
        } else if (element.action_name === 'GradeSettingsEdit' && element.enabled === 1) {
          this.gradebookSettingsEdit = true
        } else if (element.action_name === 'GradebookClassListView' && element.enabled === 1) {
          this.gradebookClassListView = true
        } else if (element.action_name === 'MarksEntry' && element.enabled === 1) {
          this.marksEntry = true
        } else if (element.action_name === 'StudentClassScheduleView' && element.enabled === 1) {
          this.studentClassScheduleView = true
        } else if (element.action_name === 'TeacherClassScheduleView' && element.enabled === 1) {
          this.teacherClassScheduleView = true
        }


        // else if (element.action_name === 'createPushTemplate' && element.enabled === 1) {
        //   this.createModuleActionNotificationTem = true
        // }
      })
    },

    checkPayoutSettingEditPermission () {
      if (this.schoolAdmin || this.payoutSettingEdit) {
        return true
      } else {
        return false
      }
    },
    checkEditPermission () {
      if (this.schoolAdmin || this.editModuleAction) {
        return true
      } else {
        return false
      }

    },
    checkViewPermission () {
      if (this.schoolAdmin || this.viewModuleAction) {
        return true
      } else {
        return false
      }
    },
    checkViewPermissionForNotification () {
      if (this.schoolAdmin || this.viewModuleActionNotification) {
        return true
      } else {
        return false
      }
    },
    checkDeletePermissionForNotificationTem () {
      if (this.schoolAdmin || this.deleteModuleActionNotificationTem) {
        return true
      } else {
        return false
      }
    },
    checkEditPermissionForNotificationTem () {
      if (this.schoolAdmin || this.editModuleActionNotificationTem) {
        return true
      } else {
        return false
      }
    },
    checkCreatePermissionForNotificationTem () {
      if (this.schoolAdmin || this.createModuleActionNotificationTem) {
        return true
      } else {
        return false
      }
    },
    checkViewPermissionForNotificationTem () {
      if (this.schoolAdmin || this.viewModuleActionNotificationTem) {
        return true
      } else {
        return false
      }
    },
    checkDeletePermission () {

      if (this.schoolAdmin || this.deleteModuleAction) {
        return true
      } else {
        return false
      }
    },
    checkCreatePermission () {


      if (this.schoolAdmin || this.createModuleAction) {
        return true

      } else {
        return false
      }
    },
    checkSendPermission () {

      if (this.schoolAdmin || this.sendModuleAction) {
        return true

      } else {
        return false
      }
    },
    checkSharePermission () {

      if (this.schoolAdmin || this.shareModuleAction) {


        return true

      } else {
        return false
      }
    },
    checkEnrollPermission () {

      if (this.schoolAdmin || this.enrollModuleAction) {


        return true

      } else {
        return false
      }
    },
    convertLead () {
      if (this.schoolAdmin || this.converModuleAction) {
        return true

      } else {
        return false
      }

    },
    checkStudentSchedulePermission () {
      if (this.schoolAdmin || this.studentSchedulePermission) {
        return true
      } else {
        return false
      }
    },
    checkRoomSchedulePermission () {
      if (this.schoolAdmin || this.roomSchedulePermission) {
        return true
      } else {
        return false
      }
    },
    checkTeacherSchedulePermission () {
      if (this.schoolAdmin || this.teacherSchedulePermission) {
        return true
      } else {
        return false
      }
    },
    checkManualEnrollmentPermission () {
      if (this.schoolAdmin || this.manualEnrollment) {
        return true
      } else {
        return false
      }
    },
    checkMarkAttendanceModule () {

      if (this.schoolAdmin || this.markAttendanceModule) {
        return true
      } else {
        return false
      }
    },
    checkSaveModulePermission () {
      if (this.schoolAdmin || this.saveModuleAction) {
        return true
      } else {
        return false
      }

    },
    checkGeneratePermission () {
      if (this.schoolAdmin || this.generateGraphModule) {
        return true
      } else {
        return false
      }
    },

    checkProjectCreatePermission () {
      if (this.schoolAdmin || this.projectCreate) {
        return true
      } else {
        return false
      }

    },
    checkProjectEditPermission () {
      if (this.schoolAdmin || this.projectEdit) {
        return true
      } else {
        return false
      }

    },
    checkProjectViewPermission () {
      if (this.schoolAdmin || this.projectView) {
        return true
      } else {
        return false
      }

    },
    checkProjectDeletePermission () {
      if (this.schoolAdmin || this.projectDelete) {
        return true
      } else {
        return false
      }

    },
    checkBlogCreatePermission () {
      if (this.schoolAdmin || this.blogCreate) {
        return true
      } else {
        return false
      }

    },
    checkBlogEditPermission () {
      if (this.schoolAdmin || this.blogEdit) {
        return true
      } else {
        return false
      }

    },
    checkBlogViewPermission () {
      if (this.schoolAdmin || this.blogView) {
        return true
      } else {
        return false
      }

    },
    checkBlogDeletePermission () {
      if (this.schoolAdmin || this.blogDelete) {
        return true
      } else {
        return false
      }

    },
    checkBlogSharePermission () {
      if (this.schoolAdmin || this.blogShare) {
        return true
      } else {
        return false
      }

    },
    checkCertificateCreatePermission () {
      if (this.schoolAdmin || this.certificateCreate) {
        return true
      } else {
        return false
      }

    },
    checkCertificateEditPermission () {
      if (this.schoolAdmin || this.certificateEdit) {
        return true
      } else {
        return false
      }

    },
    checkCertificateDeletePermission () {
      if (this.schoolAdmin || this.certificateDelete) {
        return true
      } else {
        return false
      }

    },
    checkCertificateSharePermission () {
      if (this.schoolAdmin || this.certificateShares) {
        return true
      } else {
        return false
      }

    },
    checkCertificateGeneratePermission () {
      if (this.schoolAdmin || this.certificateGeneratePermission) {
        return true
      } else {
        return false
      }

    },
    checkCertificateTemViewPermission () {
      if (this.schoolAdmin || this.certificateTempView) {
        return true
      } else {
        return false
      }

    },
    checkCertificateGenerateViewPermission () {
      if (this.schoolAdmin || this.certificategenerateView) {
        return true
      } else {
        return false
      }

    },
    checkCertificateGeneratedeletePermission () {
      if (this.schoolAdmin || this.certificategenerateDelete) {
        return true
      } else {
        return false
      }

    },
    checkCertificateTabPermission () {
      if (this.schoolAdmin || this.certificateTabView) {
        return true
      } else {
        return false
      }

    },
    checkGeneratSlipApproval () {
      if (this.schoolAdmin || this.generaatePaySlip) {
        return true
      } else {
        return false
      }
    },
    checkFinanceApproval () {
      if (this.schoolAdmin || this.financeApproval) {
        return true
      } else {
        return false
      }
    },
    checkCancelSchedule () {
      if (this.schoolAdmin || this.cancelReschedulePermission) {
        return true
      } else {
        return false
      }
    },
    checkReschedule () {
      if (this.schoolAdmin || this.Rescheduling) {
        return true
      } else {
        return false
      }
    },
    checkAdmissionEnorollPermission () {
      if (this.schoolAdmin || this.admissionEnroll) {
        return true
      } else {
        return false
      }

    },

    checkGradebookListPermission () {
      if (this.schoolAdmin || this.gradebookListView) {
        return true
      } else {
        return false
      }
    },
    checkGradebookSettingsListPermission () {
      if (this.schoolAdmin || this.gradebookSettingsListView) {
        return true
      } else {
        return false
      }
    },
    checkClassGradebookSharePermission () {
      if (this.schoolAdmin || this.gradebookClassShare) {
        return true
      } else {
        return false
      }
    },
    checkCourseGradebookSharePermission () {
      if (this.schoolAdmin || this.gradebookCourseShare) {
        return true
      } else {
        return false
      }
    },
    checkGradebookSettingsEditPermission () {
      if (this.schoolAdmin || this.gradebookSettingsEdit) {
        return true
      } else {
        return false
      }
    },
    checkGradebookClassListViewPermission () {
      if (this.schoolAdmin || this.gradebookClassListView) {
        return true
      } else {
        return false
      }
    },
    checkMarksEntryPermission () {
      if (this.schoolAdmin || this.marksEntry) {
        return true
      } else {
        return false
      }
    },
    checkStudentClassScheduleViewPermission () {
      if (this.schoolAdmin || this.studentClassScheduleView) {
        return true
      } else {
        return false
      }
    },
    checkTeacherClassScheduleViewPermission () {
      if (this.schoolAdmin || this.teacherClassScheduleView) {
        return true
      } else {
        return false
      }
    },


    // reports:false,
    // exams:false,
    // questionbank:false,
    // homework:false
    checkingAssignmentBuilder () {
      if (this.get_navmenu_item_data) this.get_navmenu_item_data.forEach(ele => {
        if (ele.module_name === 'Reports') {
          ele.action_list.forEach(eachAction => {
            if (eachAction.action_name === 'Create' && eachAction.enabled === 1) {
              this.assignmentBuilder.reports = true
              this.assignmentBuilder.questionbank = true

            }
          })
        }
        if (ele.module_name === 'Tests & Exams') {
          ele.action_list.forEach(eachAction => {
            if (eachAction.action_name === 'Create' && eachAction.enabled === 1) {
              this.assignmentBuilder.exams = true
              this.assignmentBuilder.questionbank = true

            }
          })
        }

        if (ele.module_name === 'Question Bank') {
          ele.action_list.forEach(eachAction => {
            if (eachAction.action_name === 'Create' && eachAction.enabled === 1) {
              this.assignmentBuilder.questionbank = true
            }
          })
        }

        if (ele.module_name === 'Coursework') {
          ele.action_list.forEach(eachAction => {
            if (eachAction.action_name === 'Create' && eachAction.enabled === 1) {
              this.assignmentBuilder.homework = true
              this.assignmentBuilder.questionbank = true

            }
          })
        }

      })

    }
  },
  created () {

    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    }
  },
  computed: {
    ...mapGetters(['get_navmenu_item_data'])
  }
}
